import './Device.css';

import React from 'react'

export function DeviceLayout({children}) {
  return (
    <div id="device">
      {children}
    </div>
  )
}

export function PCDevice(){
  return (
    <>
      <div id="device_pc" className="content_wrapper">
        <div className="header">
          <span><img src="./pc/images/header_logo.png" width="99px" alt="MORINAGA" /></span>
        </div>
        <div className="content_outer">
          <div className="content_inner">
            <div className="content_title"><img src="./pc/images/img_logo.png" alt="めざせ！最強！おっとっとハンター！" width="849px" /></div>
            <div className="mt25"><img src="./pc/images/img_attention.png" alt="" width="188px" /></div>
            <div className="mt35"><img src="./pc/images/img_text.png" alt="本コンテンツはスマートフォン専用のため、PCではご利用頂けません。下記QRコードよりスマートフォンからアクセスをお願いします。" width="772px" /></div>
            <div className="mt30"><img src="./pc/images/img_qr.png" width="162px" alt="" /></div>
          </div>
        </div>
        <div className="footer"><img src="./pc/images/img_copyright.png" alt="Copyright © MORINAGA & CO., LTD. All rights reserved." width="608px" /></div>
      </div>
    </>
  )
}

export function IOSDevice() {

  return (
    <>
      <div id="alert_web" className="content_wrapper">
        <div className="content_header">
          <div className="content_attention"><img src="./images/alert/txt_attention.png" width="100%" alt="恐竜バトルを楽しもう！" /></div>
        </div>

        <div className="content_body">
          <div className="content_body_inner">
            <div className="content_title"><img src="./images/alert/txt_ios.png" width="100%" alt="iPhoneの場合" /></div>
            <div className="mb70"><img src="./images/alert/txt_line.png" width="28.209%" alt="(例)LINEの場合" /></div>
            <div className="mb65"><img src="./images/alert/ios_step1.png" width="76.567%" alt="1.右上のボタンをタップ" /></div>
            <div className="mb65"><img src="./images/alert/icon_arrow.png" width="14.627%" alt="" /></div>
            <div className="mb65"><img src="./images/alert/ios_step2.png" width="76.567%" alt="2.Safariで開くをタップ" /></div>
            <div className="mb65"><img src="./images/alert/icon_arrow.png" width="14.627%" alt="" /></div>
            <div className="pb90"><img src="./images/alert/ios_step3.png" width="76.567%" alt="3.Safariブラウザでページを開いてコンテンツを遊ぼう！" /></div>
          </div>
        </div>
        <footer className="content_footer">
          <div className="mb45"><img src="./images/logo.png" width="37.6%" alt="おっとっと" /></div>
          <div><img src="./images/copyright.png" width="86.133%" alt="Copyright © MORINAGA & CO., LTD. All rights reserved." /></div>
        </footer>
      </div>
    </>
  )
}

export function AndroidDevice() {

  return (
    <>
      <div id="alert_web" className="content_wrapper">
        <div className="content_header">
          <div className="content_attention"><img src="./images/alert/txt_attention.png" width="100%" alt="恐竜バトルを楽しもう！" /></div>
        </div>

        <div className="content_body">
          <div className="content_body_inner">
            <div className="content_title"><img src="./images/alert/txt_android.png" width="100%" alt="Androidの場合" /></div>
            <div className="mb70"><img src="./images/alert/txt_line.png" width="28.209%" alt="(例)LINEの場合" /></div>
            <div className="mb65"><img src="./images/alert/ios_step1.png" width="76.567%" alt="1.右上のボタンをタップ" /></div>
            <div className="mb65"><img src="./images/alert/icon_arrow.png" width="14.627%" alt="" /></div>
            <div className="mb65"><img src="./images/alert/ios_step2.png" width="76.567%" alt="2.他のアプリで開くをタップ " /></div>
            <div className="mb65"><img src="./images/alert/icon_arrow.png" width="14.627%" alt="" /></div>
            <div className="pb90"><img src="./images/alert/ios_step3.png" width="76.567%" alt="3.推奨ブラウザでページを開いてコンテンツを遊ぼう！ " /></div>
          </div>
        </div>
        <footer className="content_footer">
          <div className="mb45"><img src="./images/logo.png" width="37.6%" alt="おっとっと" /></div>
          <div><img src="./images/copyright.png" width="86.133%" alt="Copyright © MORINAGA & CO., LTD. All rights reserved." /></div>
        </footer>
      </div>
    </>
  )
}